import { Box, CircularProgress } from "@mui/material";

const Loader = () => (
  <Box
    p={3}
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
    }}
  >
    <CircularProgress size={40} />
  </Box>
);

export default Loader;
